module.exports = __webpack_public_path__ + "static/media/carbon.5ce1781d.png";